<template>
  <div>
    <jd-form
      ref="orderDetailRef"
      class="mb16"
      :form-info="inputGoodsDetail"
      :btn30="true"
      @search="searchOrderDetail"
    />
    <div class="mb16 flex-end">
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>
    <jd-table
      :loading="loading"
      :tableInfo="tableInfo"
      :isIndex="true"
      :tableData="orderDetailData"
      :pageInfo="{
        pageNum: goodsDetailPage.current,
        pageSize: goodsDetailPage.size,
        total: total,
      }"
      @sort-change="sortChange"
      @handlePage="
        (val) => {
          (this.goodsDetailPage.current = val.pageNum),
            (this.goodsDetailPage.size = val.pageSize);
            getList();
        }
      "
    >
    </jd-table>
    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
  </div>
</template>

<script>
import { getSkuDetailStats,getSkuDetailStatsExport } from "@/api/jhk/paradiseAndTaskCommonController.js";
export default {
  props: {
    rowData: {
      // 活动数据
      type: Object,
      default: () => {},
    },
    sellerLinkList: {
      type: Array,
      default: () => [],
    },
    shopList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputGoodsDetail: [
        {
          label: "下单时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          startTime: this.rowData.startTime, // 活动开始时间
          endTime: this.getEndTime(this.rowData.startTime,7) + " 23:59:59", //活动开始时间后7天
          startKey: "orderStartTime",
          endKey: "orderEndTime",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
        },
        {
          label: "SKUID：",
          prop: "skuIds",
          type: "Input",
          placeholder: "请输入SKUID,多个请用“，”隔开",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: [],
        },
      ],
      loading: false, // 加载
      orderDetailData: [], // 订单明细
      goodsDetailPage: {
        orderStartTime: this.rowData.startTime,
        orderEndTime: this.getEndTime(this.rowData.startTime,7) + " 23:59:59",
        skuIds: "",
        sellerLinkId: "",
        current: 1, // 当前页
        size: 10, // 每页条数
        orderField: "",
        orderType: ""
      },
      tableInfo: [
        {
          label: "商品名称",
          prop: "skuName",
        },
        {
          label: "SKUID",
          prop: "skuId",
        },
        {
          label: "单价",
          prop: "prize",
        },
        {
          label: "下单客户数",
          prop: "orderUserCount",
          sortable: true,
        },
        {
          label: "下单订单数",
          prop: "orderCount",
          sortable: true,
        },
        {
          label: "下单金额",
          prop: "orderAmount",
          sortable: true,
        },
        {
          label: "下单件数",
          prop: "orderProductCount",
          sortable: true,
        },
        {
          label: "客单价",
          prop: "orderCustomerPrice",
          sortable: true,
        },
        {
          label: "均单价",
          prop: "orderAveragePrice",
          sortable: true,
        },
      ],
      openRemarkDialog: false,
      total: 0,
    };
  },
  watch: {
    sellerLinkList: {
      handler(newVal, oldVal) {
        if (newVal.length) {
          const list = newVal.map((item) => {
            return {
              label: item.sellerLinkName,
              value: item.id,
            };
          });
          this.inputGoodsDetail.some((item) => {
            if (item.prop == "sellerLinkId") {
              item.options = list;
            }
          });
        }
      },
      immediate: true,
      deep: true,
    },
    shopList: {
      handler(newVal, oldVal) {
        if (newVal.length) {
          const list = newVal.map((item) => {
            return {
              label: item.shopTitle,
              value: item.venderId,
            };
          });
          this.inputGoodsDetail.some((item) => {
            if (item.prop == "orderVenderId") {
              item.options = list;
            }
          });
        }
      },
      deep: true,
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getEndTime(time,AddDayCount) {
      var dd = new Date(time);    
        dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期    
        var y = dd.getFullYear();    
        var m = dd.getMonth()+1;//获取当前月份的日期    
        var d = dd.getDate();    
      return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    },
    confirmExport(exportRemark = "") {
      let params = {
        ...this.goodsDetailPage,
        activityId: this.rowData.id,
        exportRemark,
      };
      getSkuDetailStatsExport(params).then((res) => {
       
      });
    },
    exportAll() {
      this.openRemarkDialog = true;
    },
    sortChange({ column, property, order }) {
      if (order == "ascending") {
        this.goodsDetailPage.orderType = 0;
        // 升序
      } else if (order == "descending") {
        this.goodsDetailPage.orderType = 1;
        // 降序
      }
      this.goodsDetailPage.orderField = column.property;
      this.getList()
    },
    getList() {
      console.log(this.rowData,'gvfvvc');
      this.loading = true;
      getSkuDetailStats({ ...this.goodsDetailPage, activityId: this.rowData.id })
        .then((res) => {
          if(res.code==1) {
            let { records = [], total = 0 } = res.data || {};
            this.loading = false;
            this.orderDetailData = records;
            this.total = Number(total);
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          
          this.loading = false;
        });
    },
    // 订单明细搜索
    searchOrderDetail(val) {
      this.goodsDetailPage.orderStartTime = val.orderStartTime || "";
      this.goodsDetailPage.orderEndTime = val.orderEndTime || "";
      this.goodsDetailPage.skuIds = val.skuIds || "";
      this.goodsDetailPage.sellerLinkId = val.sellerLinkId || "";
      this.goodsDetailPage.current = 1;
      this.goodsDetailPage.size = 10;
      this.getList()
    },
  },
};
</script>

<style lang="scss" scoped></style>
